import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Section from './Section';
import Name from './Name';
import Subtitle from './Subtitle';
import messages from '../messages';

const SectionList = ({ sections, onClickSection, intl: { formatMessage } }) =>
  sections.map((section, index) => (
    <Section key={section.id} onClick={() => onClickSection(section.id, index)}>
      <Name>{section.name}</Name>
      <Subtitle>
        {formatMessage(messages.products, {
          total: section.products?.length || 0,
        })}
      </Subtitle>
    </Section>
  ));

SectionList.propTypes = {
  onClickSection: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
  intl: intlShape,
};

export default injectIntl(memo(SectionList));
